import { render, staticRenderFns } from "./GastoTipos.vue?vue&type=template&id=f3011136&scoped=true"
import script from "./GastoTipos.vue?vue&type=script&lang=js"
export * from "./GastoTipos.vue?vue&type=script&lang=js"
import style0 from "./GastoTipos.vue?vue&type=style&index=0&id=f3011136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3011136",
  null
  
)

export default component.exports